<template>
  <div @click.capture="handleLoyaltyHubNavClick">
    <ClientOnly>
      <LeftNavShell
        class="grid-container"
        :no-accordion="isBcom"
      >
        <template
          v-if="isMcom"
          #custom-header
        >
          <li class="left-nav-link-block left-nav-header-wrapper">
            <a
              class="large"
              href="/myaccount/home"
            >
              My Account
            </a>
          </li>
        </template>
      </LeftNavShell>
      <template #fallback>
        <nav
          class="account-navigation grid-container"
          aria-label="Account navigation"
          aria-busy="true"
        >
          <ul class="left-nav"></ul>
        </nav>
      </template>
    </ClientOnly>
  </div>
</template>

<script setup>
import { computed, nextTick } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import LeftNavShell from '@nuxt-common/left-nav/app/components/LeftNav.vue';
import { LOYALTY_HUB_BASE_PATH, resolveLoyaltyHubNavTarget } from '../utils/loyaltyHubNavLinks';
import { isValidLoyaltyHubSection, normalizeLoyaltyHubSection, scrollToLoyaltyHubSection } from '../utils/loyaltyHubSectionScrollUtil';

const runtimeConfig = useRuntimeConfig();
const router = useRouter();
const route = useRoute();
const brand = computed(() => runtimeConfig.public.brandEntryPoint || 'bcom');
const isMcom = computed(() => brand.value === 'mcom');
const isBcom = computed(() => brand.value === 'bcom');
const hubPath = computed(() => LOYALTY_HUB_BASE_PATH[brand.value]);

const scrollToHubSection = async (section) => {
  if (!isValidLoyaltyHubSection(section, brand.value)) {
    return;
  }

  await nextTick();
  await scrollToLoyaltyHubSection(section, {
    maxAttempts: 50,
    intervalMs: 100,
    followUpDelays: [300, 800, 1500],
  });
};

const handleLoyaltyHubNavClick = async (event) => {
  const anchor = event.target.closest('a[href]');

  if (!anchor) {
    return;
  }

  const href = anchor.getAttribute('href');
  const navTarget = resolveLoyaltyHubNavTarget(href, brand.value);

  if (!navTarget || route.path !== hubPath.value) {
    return;
  }

  event.preventDefault();

  const section = normalizeLoyaltyHubSection(navTarget.query.section);

  try {
    await router.push(navTarget);
  } catch {
    // Same-route navigation still needs to re-scroll to the section.
  }

  await scrollToHubSection(section);
};
</script>
